// extracted by mini-css-extract-plugin
export default {"selected":"ColorDropdown_selected__tYEoo"};